import './PropertyStatistics.scss';
import Component from './PropertyStatistics.js';
export default Component;